import React, {useCallback, useContext, useRef} from 'react';
import UserContext from '../../common/UserContext.js';

// react strap
import {Col, Row} from 'reactstrap';

// components
import {PopoverContext} from '../LicenseDownload.js';
import {downloadLicenses} from '../../common/utilities.js';

// kendo react
import {Tooltip} from '@progress/kendo-react-tooltip';
import {Loader} from '@progress/kendo-react-indicators';

// multilingual
import {useLocalization} from '@progress/kendo-react-intl';
import {
    downloadLicensesKey,
    hostKey,
    loadingGenerationKey,
    mainMessages
} from '../../../assets/text/MultilingualText.js';
import {DownloadIcon, WarningErrorIcon} from "../../common/icons";
import {
    AssignedPanelbarTitle
} from "../../common/RequestLicense/AssignedPanelbarTitle";


export const PanelBarHeader = (props) => {
    const {
        host,
        setIsLoading,
        handleBeforeUnload
    } = props;
    const {
        accessToken,
        siteLanguageDefault
    } = useContext(UserContext);
    const localization = useLocalization();

    // sets the popover reference based on mouse over
    const popoverRef = useRef(null);
    const {onMouseOver} = useContext(PopoverContext);

    const handleMouseOver = useCallback(() => {
        const icons = host.icons;
        onMouseOver({
            show: true,
            popoverRef: popoverRef,
            generalError: icons.generalError,
            networkError: icons.networkError
        });
    }, [onMouseOver, host.icons]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleMouseOut = useCallback(() => {
        const icons = host.icons;
        onMouseOver({
            show: false,
            popoverRef: popoverRef,
            generalError: icons.generalError,
            networkError: icons.networkError
        });
    }, [onMouseOver, host.icons]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <Row
                style={{
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                <Col
                    style={{
                        flex: '0 0 auto',
                        width: 'auto'
                    }}
                >
                    <AssignedPanelbarTitle text={`${localization.toLanguageString(hostKey, mainMessages[siteLanguageDefault][hostKey])} ${host.host_id}`} />
                </Col>
                <Col/>
                {host.icons.loading && (
                    <Col
                        style={{
                            justifyContent: 'center',
                            display: 'flex',
                            position: 'absolute',
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 1,
                        }}
                    >
                        <Tooltip
                            anchorElement="pointer"
                            showCallout={true}
                            parentTitle={true}
                            openDelay={0}
                            filter={(e) => {
                                const classNames = ['k-loader k-loader-md k-loader-primary k-loader-pulsing-2', 'k-loader-segment', 'k-loader-canvas']
                                if (classNames.includes(e.className)) {
                                    return true;
                                }
                            }}
                        >
                            <div
                                title={localization.toLanguageString(loadingGenerationKey, mainMessages[siteLanguageDefault][loadingGenerationKey])}
                                style={{
                                    paddingBottom: '1px'
                                }}
                            >
                                <Loader
                                    type={'converging-spinner'}
                                    style={{
                                        color: 'white'
                                    }}
                                />
                            </div>
                        </Tooltip>
                    </Col>
                )}
                            
                <Col>
                    <div
                        style={{
                            float: 'right'
                        }}
                    >
                        <div>
                            {host.icons.download && (<Tooltip
                                anchorElement="pointer"
                                showCallout={true}
                                parentTitle={true}
                                openDelay={0}
                            >
                                <div
                                    title={localization.toLanguageString(downloadLicensesKey, mainMessages[siteLanguageDefault][downloadLicensesKey])}
                                    onClick={() => {
                                        downloadLicenses([host['transaction_id']], accessToken, setIsLoading, handleBeforeUnload);
                                    }}
                                >
                                    <DownloadIcon
                                        size={'medium'}
                                        style={{
                                            color: 'white',
                                            marginTop: '0.35rem',
                                            marginLeft: '0.35rem',
                                            marginRight: '0.35rem',
                                            cursor: 'pointer'
                                        }}
                                    />
                                </div>
                            </Tooltip>)}
                            {(host.icons.generalError || host.icons.networkError) && !host.icons.download && (
                                <div
                                    onMouseOver={handleMouseOver}
                                    onMouseOut={handleMouseOut}
                                    ref={popoverRef}
                                >
                                    <WarningErrorIcon
                                        size={'medium'}
                                        style={{
                                            color: 'var(--keysight-pink)',
                                            marginTop: '0.35rem',
                                            marginLeft: '0.35rem',
                                            marginRight: '0.35rem',
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    )
}